import React from 'react';
import PlacesSearchBox from 'common/components/core/map/PlacesSearchBox';
import { AddressLatLng } from 'common/models/internal/AddressLatLng';

class EntityPlacesSearchBox extends React.PureComponent {
    handleLocationChange = (lat, lng, description) => {
        let addressLatLng = null;

        if (lat || lng || description) {
            addressLatLng = AddressLatLng.fromJS({
                address: description,
                latLng: {
                    lat,
                    lng,
                    accuracy: 0
                }
            });
        }

        const { onChange } = this.props;
        onChange && onChange(addressLatLng);
    };

    render() {
        const { theme, location, placeholder } = this.props;

        return (
            <PlacesSearchBox
                fullWidth
                useDefaultCenter
                placeholder={placeholder}
                selectedAddress={location && location.getAddressString()}
                onPlacesChanged={this.handleLocationChange}
                className={theme.inputField}
                theme={theme}
                onPlacesClear={this.handleLocationChange}
            />
        );
    }
}

export default EntityPlacesSearchBox;
